import { Reveal } from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import { VALUE_DIMENSIONS } from "@/data/content";

export default function ValueDimensions() {
  return (
    <section data-testid="value-section" className="relative bg-oxford diagonal-lines overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
        <SectionHeader dark eyebrow="Propuesta de valor" title="Generamos valor donde realmente importa." />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-5 border-t border-white/10">
          {VALUE_DIMENSIONS.map((d, i) => (
            <Reveal key={d.title} delay={i * 0.1} className="h-full">
              <div className="group h-full p-8 lg:p-7 border-b sm:border-b-0 border-white/10 sm:border-l sm:first:border-l-0 transition-colors duration-300 hover:bg-white/[0.03]">
                <span className="font-display text-4xl lg:text-5xl font-bold text-gold/90">0{i + 1}</span>
                <d.icon className="mt-8 h-6 w-6 text-gold" strokeWidth={1.5} />
                <h3 className="mt-4 font-display text-sm font-semibold tracking-[0.2em] uppercase text-white">{d.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-steel">{d.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
